export const types = <const>{
	mutations: {
		DODAVATEL_SELECT_MAPPER: 'DODAVATEL_SELECT_MAPPER',
		INTR_ZAKAZNIK_SELECT_MAPPER: 'INTR_ZAKAZNIK_SELECT_MAPPER',
		FN1_DODAVATEL_SELECT_MAPPER: 'FN1_DODAVATEL_SELECT_MAPPER',
		INTERNI_DRUH_SELECT_MAPPER: 'INTERNI_DRUH_SELECT_MAPPER',
		SKLAD_PREVOD_INTERNI_DRUH_SELECT_MAPPER: 'SKLAD_PREVOD_INTERNI_DRUH_SELECT_MAPPER',
		SET_PROVOZOVNA_TABLE: 'setProvozovnaTable',
		SET_TABLE_LOADING: 'setTableLoading',
		PRIMARY_BANK_SELECT_MAPPER: 'PRIMARY_BANK_SELECT_MAPPER',
		SECONDARY_BANK_SELECT_MAPPER: 'SECONDARY_BANK_SELECT_MAPPER',
		DEALERKVPS_SELECT_MAPPER: 'DEALERKVPS_SELECT_MAPPER',
	},
	actions: {
		GET_PROVOZOVNA_TABLE_SCHEMA_AND_ROWS: 'getProvozovnaTableSchemaAndRows',
	},
};
